import { arrayUnion, doc, updateDoc } from "firebase/firestore";
import { getMessaging, getToken } from "firebase/messaging";

import app, { db } from "../firebase";

/**
 * Called from the existing notification bar in App.js after Notification permission is granted.
 * Requires REACT_APP_FIREBASE_VAPID_KEY (public Web Push key).
 */
export async function registerFcmToken(userId) {
  if (!userId) throw new Error("Sign in required.");
  if (typeof window === "undefined" || !("Notification" in window) || !("serviceWorker" in navigator)) {
    throw new Error("Push is not supported in this browser.");
  }
  const vapidKey = process.env.REACT_APP_FIREBASE_VAPID_KEY;
  if (!vapidKey) {
    throw new Error(
      "REACT_APP_FIREBASE_VAPID_KEY is not set. Generate a Web Push key pair in the Firebase console."
    );
  }

  const permission = await Notification.requestPermission();
  if (permission !== "granted") return { permission, token: null };

  const registration = await navigator.serviceWorker.register("/firebase-messaging-sw.js");
  const messaging = getMessaging(app);
  const token = await getToken(messaging, { vapidKey, serviceWorkerRegistration: registration });
  if (!token) return { permission, token: null };

  await updateDoc(doc(db, "users", userId), {
    fcmTokens: arrayUnion(token),
  });
  return { permission, token };
}
